import { render } from "./PandALogin.vue?vue&type=template&id=797ba426&ts=true"
import script from "./PandALogin.vue?vue&type=script&lang=ts"
export * from "./PandALogin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__